import { ExtraServiceWithTimeSlice } from '@numa-group/checkout-api';
import { AxiosInstance } from 'axios';

import { IAuthService } from '@src/features/auth/services/i-auth-service';
import { serviceOffer } from '@src/mocks/__fixtures__/offers/service-offer';
import { OfferRepository } from '@src/services/api/offers/offer.repository';
import { GetOffersResponse } from '@src/types/api/models/offers';

export class OfferRepositoryMock implements OfferRepository {
  constructor(
    private readonly axiosInstance: AxiosInstance,
    private readonly authService: IAuthService,
  ) {}

  async getOffers(): Promise<GetOffersResponse> {
    throw new Error('Method not implemented.');
  }

  async getServiceOffers(): Promise<ExtraServiceWithTimeSlice[]> {
    return serviceOffer;
  }
}
